import { render, staticRenderFns } from "./HappinessSettings.vue?vue&type=template&id=4cb50c96&"
import script from "./HappinessSettings.vue?vue&type=script&lang=js&"
export * from "./HappinessSettings.vue?vue&type=script&lang=js&"
import style0 from "./HappinessSettings.vue?vue&type=style&index=0&id=4cb50c96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports